
export default class

  @make: (message) -> alert "JS error: #{ message }"
